import {Component, Input, Output, EventEmitter} from '@angular/core';
import { AppState } from '../../../app/app.global';
/*
 Generated class for the MySlide component.

 See https://angular.io/docs/ts/latest/api/core/ComponentMetadata-class.html
 for more info on Angular 2 Components.
 */
@Component({
  selector: 'my-slide',
  templateUrl: 'my-slide.html'
})
export class MySlide {

  @Input("slides") slides:any[]=[];
  slidesShow:any[] = [];
  @Input("pageNumber") pageNumber:number = 5;
  @Output("slideClick") slideClick = new EventEmitter<number>();

  mySlideOptions:any;
  selectedIndex:number = 0;

  constructor(public global: AppState) {
    this.slidesShow = this.global.slidesShow;
  }

  ngOnInit() {
    this.mySlideOptions = {
      loop: false,
     //autoplay: false,
      initialSlide: 0,
      pager: false,
      slidesPerView: this.pageNumber,
      paginationHide: true,
      paginationClickable: true
    };
  }

  onClick(index:any) {
    this.selectedIndex = index;
    this.slideClick.emit(index);
  }
}



// WEBPACK FOOTER //
// ./src/pages/comm/my-slide/my-slide.ts